export const FILES_PANEL_TEXT = {
  UPLOAD_NOTES: [
    '1. Encrypted or password-protected files are not accepted.',
    '2. Only PDF format is accepted.',
    '3. Each file may not exceed 10MB. ',
  ],
};
